import { render } from "./VerifiedIcon.vue?vue&type=template&id=0a1478ea&scoped=true"
import script from "./VerifiedIcon.vue?vue&type=script&lang=js"
export * from "./VerifiedIcon.vue?vue&type=script&lang=js"

import "./VerifiedIcon.vue?vue&type=style&index=0&id=0a1478ea&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1478ea"]])

export default __exports__